<template>
  <div>
    <ApplicationStepperContent :is_terminated="is_terminated" :admission_id="admission_id" :applicationDetails="admissionDetails.application_details" :class_standards="class_standards" :is_editing="is_editing" :is_from_portal="is_from_portal" :readonly="true"/>
    <UploadedDocumentsStepperContent :is_terminated="is_terminated" :admission_id="admission_id" :doctypes="doctypes" :admissionDocs="admissionDetails.admission_docs" :is_editing="true" :readonly="true"/>
    <v-snackbar v-model="snackbar.visible">
        <span>{{ snackbar.text }}</span>
        <template>
          <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
        </template>
      </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
// import Helper from "@utils/misc";
import UploadedDocumentsStepperContent from "@components/admission/admissiondetails/UploadedDocumentsStepperContent";
import ApplicationStepperContent from "@components/admission/admissiondetails/ApplicationStepperContent";

export default {
  name: "EvaluationStepperContent",
  data() {
    return {
      snackbar: {
      text: null,
      visible: false
    }
    }
  },
  props:{
    admissionDetails: {
      default: () => {
        return {
          application_details: {},
          admission_docs : [],
        }
      },
      type: Object
    },
    is_terminated: {
      default: true,
      type: Boolean,
    },
    class_standards : {
      default: () => [],
      type: Array,
    },
    is_editing: {
      default: false,
      type: Boolean,
    },
    is_from_portal: {
      default: false,
      type: Boolean,
    },
    doctypes: {
      default: () => [],
      type: Array,
    },
    admissionDocs: {
      default: () => [],
      type: Array,
    },
    admission_id: null,

    

  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods:{
    ...mapActions(["setLoading"]),

    // Do not TOUCH or change names 
    async saveFormDetails(){
      var url = endpoints.admissions + `evaluation/${this.admission_id}/`;
      var post_body = {}
      var response = await api.call(this.apiEssentials,url, api.Methods.POST, post_body);
      if (response instanceof Error){
        this.setLoading(false);
        this.snackbar.text = "Error saving details";
        this.snackbar.visible = true;
        return;
      }
      // this.$router.push({name: 'EditAdmissionDetails', params: { admission_id: response.id }});
      this.snackbar.text = "Evaluated Successfully!";
      this.snackbar.visible = true;
      this.$emit("save-response",{ step: 4 ,name: 'evaluationDetails', value: response});
    },

  },
  components: {
    UploadedDocumentsStepperContent: UploadedDocumentsStepperContent,
    ApplicationStepperContent: ApplicationStepperContent,
  },
};
</script>

<style>
</style>